module.exports = "<itpx-address-form-component \n    [data]=\"details\"\n    [isEdit]=\"true\"\n    (isCancel)=\"isCancel()\"\n    (isSaved)=isSaved()>\n</itpx-address-form-component>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/organization-details/organization-details-edit/address/address-edit/address-edit.component.html
// module id = ./src/app/organization/components/organization-details/organization-details-edit/address/address-edit/address-edit.component.html
// module chunks = main